import { useMutation } from '@tanstack/react-query';
import { DeletePricingResponse } from '@spilca/order_ts/v1/order_web/pricing_web_pb';
import { TGRPCPromiseReject } from '@monorepo/grpc';
import { REQUEST_TYPES, useGetRequest } from '@monorepo/requests';

const useDeletePricing = () => {
  const mutator = useGetRequest(REQUEST_TYPES.DELETE_PRICING);

  return useMutation<DeletePricingResponse | null, TGRPCPromiseReject, number>({
    mutationFn: mutator,
    retry: false
  });
};

export default useDeletePricing;
